import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoAwardRibbon = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>AwardRibbon</title>
    <path
      d="M16.998 21.56a9.143 9.143 0 1 0 0-18.286 9.143 9.143 0 0 0 0 18.286Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m12.668 20.43-1.383 10.411 5.714-3.428 5.714 3.428L21.33 20.42"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoAwardRibbon;
